/* eslint-disable spellcheck/spell-checker */

import { getDateTimeFromIso } from './helpers';
import { FormStatuses, APSV2Form, FormLayout } from '../../types';

// translate APS response to Cacahute, this should be only temporary until we fully migrate to APS
const translateResponse = (
  form: APSV2Form,
  layout: FormLayout | null,
  metadata: {
    projectId: string;
    signedPDFUrls: { fileUrl: string; thumbnailUrl: string };
  },
) => {
  const mapResponseData = (form: APSV2Form) => {
    const formKeyMapping: Record<string, string> = {
      createdBy: 'created_by',
      createdAt: 'created_at',
      formDate: 'report_date',
      formTemplateId: 'type',
      id: 'uid',
      lastFetchedAt: 'last_fetched_at',
      updatedAt: 'updated_at',
      updatedBy: 'updated_by',
      userCreatedAt: 'user_created_at',
      nativeForm: 'pg_form',
      pdfFile: 'file',
      formNum: 'report_num',
      dueDate: 'due_date',
      locationId: 'location_id',
      assigneeId: 'assignee_id',
      assigneeType: 'assignee_type',
      description: 'title',
      notes: 'description',
    };

    // An object of value translation functions: key is the new query param key, the value is the translation function
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const valueMapping: Record<string, (apsValue: any) => any> = {
      status: (oldValue: FormStatuses) => {
        const statusMap: Record<FormStatuses, string> = {
          inProgress: 'draft',
          inReview: 'in_review',
          closed: 'submitted',
          archived: 'archived',
        };
        return statusMap[oldValue] || oldValue;
      },
      due_date: getDateTimeFromIso,
      created_at: getDateTimeFromIso,
      last_fetched_at: getDateTimeFromIso,
      report_date: getDateTimeFromIso,
      user_created_at: getDateTimeFromIso,
      updated_at: getDateTimeFromIso,
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cacaForm: Record<string, any> = {};
    // translate keys/values
    Object.entries(form).forEach(([key, value]) => {
      const newKey = formKeyMapping[key] || key;
      const newValue = valueMapping[newKey]
        ? valueMapping[newKey]?.(value)
        : value;

      if (newValue !== null) {
        cacaForm[newKey] = newValue;
      }
    });

    cacaForm.project = metadata.projectId;
    if (form.pdfFile) {
      const urls = {
        file: metadata.signedPDFUrls.fileUrl,
        thumbnail: metadata.signedPDFUrls.thumbnailUrl,
      };
      cacaForm.file = {
        filename: form.pdfFile.fileName,
        uid: form.pdfFile.id,
        size: form.pdfFile.size,
        urls,
      };
      cacaForm.urls = urls;
    }

    return cacaForm;
  };

  return mapResponseData(form);
};

const getFormTransformers = {
  translateResponse,
};

export default getFormTransformers;
